function dropdown() {
    const mediaQuery = window.matchMedia('(max-width: 767px)');
    const head = document.querySelector('.gh-navigation');

    if (!head) return;

    const menu = head.querySelector('.gh-navigation-menu');
    const nav = menu?.querySelector('.nav');

    if (!menu || !nav) return;

    const inner = head.querySelector('.gh-navigation-inner') || head;
    const logo = head.querySelector('.gh-navigation-logo');
    const burger = head.querySelector('.gh-burger');
    const navHTML = nav.innerHTML;
    let resizeTimer;

    const normalizePath = function (path) {
        const normalized = path.replace(/\/+$/, '');
        return normalized || '/';
    };

    const setCurrentLinks = function () {
        const currentURL = new URL(window.location.href);
        let activeTopic = false;

        nav.querySelectorAll('a[href]').forEach(function (link) {
            const targetURL = new URL(link.href, currentURL);
            const isCurrent = targetURL.origin === currentURL.origin
                && normalizePath(targetURL.pathname) === normalizePath(currentURL.pathname);

            if (isCurrent) {
                link.setAttribute('aria-current', 'page');
                link.closest('li')?.classList.add('is-current');

                if (link.closest('.rx-topics-menu')) {
                    activeTopic = true;
                }
            }
        });

        nav.querySelector('.rx-nav-topics')?.classList.toggle('is-current-section', activeTopic);
    };

    const closeTopics = function (returnFocus) {
        nav.querySelectorAll('.rx-nav-topics.is-open').forEach(function (item) {
            const toggle = item.querySelector('.rx-topics-toggle');
            item.classList.remove('is-open');
            toggle?.setAttribute('aria-expanded', 'false');

            if (returnFocus) {
                toggle?.focus();
            }
        });
    };

    const closeMore = function (returnFocus) {
        const toggle = nav.querySelector('.gh-more-toggle');
        const wasOpen = head.classList.contains('is-dropdown-open');

        head.classList.remove('is-dropdown-open');
        toggle?.setAttribute('aria-expanded', 'false');

        if (returnFocus && wasOpen) {
            toggle?.focus();
        }
    };

    const setMobileDelays = function () {
        nav.querySelectorAll('li').forEach(function (item, index) {
            item.style.transitionDelay = mediaQuery.matches ? `${0.03 * (index + 1)}s` : '';
        });
    };

    const makeDropdown = function () {
        head.classList.remove('is-dropdown-loaded', 'is-dropdown-open', 'is-dropdown-mega');

        if (mediaQuery.matches) {
            head.classList.add('is-dropdown-loaded');
            return;
        }

        const submenuItems = [];

        // The 64px in the loop below reserves room for the "more" toggle, so it
        // must only be paid once that toggle actually has to exist. When the bar
        // still has slack the reserve pushes the last item into a dropdown for
        // no reason. `menu` sits in a 1fr grid column that never reports less
        // than its min-content width, so a squeezed nav measures as "fitting" -
        // check the header row for real overflow as well.
        if (nav.offsetWidth <= menu.offsetWidth && inner.scrollWidth <= inner.clientWidth) {
            head.classList.add('is-dropdown-loaded');
            return;
        }

        while ((nav.offsetWidth + 64) > menu.offsetWidth) {
            if (nav.lastElementChild) {
                submenuItems.unshift(nav.lastElementChild);
                nav.lastElementChild.remove();
            } else {
                break;
            }
        }

        if (!submenuItems.length) {
            head.classList.add('is-dropdown-loaded');
            return;
        }

        const moreItem = document.createElement('li');
        moreItem.setAttribute('class', 'gh-more-item');

        const toggle = document.createElement('button');
        toggle.setAttribute('class', 'gh-more-toggle gh-icon-button');
        toggle.setAttribute('type', 'button');
        toggle.setAttribute('aria-label', 'More links');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-controls', 'gh-navigation-more');
        toggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor" aria-hidden="true"><path d="M21.333 16c0-1.473 1.194-2.667 2.667-2.667s2.667 1.194 2.667 2.667-1.194 2.667-2.667 2.667-2.667-1.194-2.667-2.667zm-8 0c0-1.473 1.194-2.667 2.667-2.667s2.667 1.194 2.667 2.667-1.194 2.667-2.667 2.667-2.667-1.194-2.667-2.667zm-8 0c0-1.473 1.194-2.667 2.667-2.667S10.667 14.527 10.667 16 9.473 18.667 8 18.667 5.333 17.473 5.333 16z"></path></svg>';

        const wrapper = document.createElement('ul');
        wrapper.setAttribute('id', 'gh-navigation-more');
        wrapper.setAttribute('class', 'gh-dropdown');
        wrapper.setAttribute('aria-label', 'More journal links');

        if (submenuItems.length >= 10) {
            head.classList.add('is-dropdown-mega');
            wrapper.style.gridTemplateRows = `repeat(${Math.ceil(submenuItems.length / 2)}, 1fr)`;
        }

        submenuItems.forEach(function (child) {
            wrapper.appendChild(child);
        });

        moreItem.appendChild(toggle);
        moreItem.appendChild(wrapper);
        nav.appendChild(moreItem);

        const toggleRect = toggle.getBoundingClientRect();
        const documentCenter = window.innerWidth / 2;

        if (toggleRect.left < documentCenter) {
            wrapper.classList.add('is-left');
        }

        head.classList.add('is-dropdown-loaded');
    };

    const renderNavigation = function () {
        closeTopics(false);
        closeMore(false);
        nav.innerHTML = navHTML;
        setMobileDelays();
        setCurrentLinks();
        makeDropdown();
    };

    const scheduleRender = function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(renderNavigation, 80);
    };

    nav.addEventListener('click', function (event) {
        const moreToggle = event.target.closest('.gh-more-toggle');

        if (moreToggle) {
            const willOpen = !head.classList.contains('is-dropdown-open');
            closeTopics(false);
            head.classList.toggle('is-dropdown-open', willOpen);
            moreToggle.setAttribute('aria-expanded', String(willOpen));
            return;
        }

        const topicsToggle = event.target.closest('.rx-topics-toggle');

        if (topicsToggle) {
            const item = topicsToggle.closest('.rx-nav-topics');
            const willOpen = !item.classList.contains('is-open');

            closeTopics(false);
            item.classList.toggle('is-open', willOpen);
            topicsToggle.setAttribute('aria-expanded', String(willOpen));
            return;
        }

        if (event.target.closest('a')) {
            closeTopics(false);
            closeMore(false);
        }
    });

    nav.addEventListener('keydown', function (event) {
        const topicsToggle = event.target.closest('.rx-topics-toggle');

        if (topicsToggle && event.key === 'ArrowDown') {
            event.preventDefault();
            const item = topicsToggle.closest('.rx-nav-topics');
            closeTopics(false);
            item.classList.add('is-open');
            topicsToggle.setAttribute('aria-expanded', 'true');
            item.querySelector('.rx-topics-menu a')?.focus();
            return;
        }

        if (event.key === 'Escape') {
            if (nav.querySelector('.rx-nav-topics.is-open')) {
                event.preventDefault();
                closeTopics(true);
            } else if (head.classList.contains('is-dropdown-open')) {
                event.preventDefault();
                closeMore(true);
            }
        }
    });

    document.addEventListener('click', function (event) {
        if (!nav.contains(event.target)) {
            closeTopics(false);
            closeMore(false);
        }
    });

    const syncBurgerState = function () {
        if (!burger) return;

        const isOpen = head.classList.contains('is-open');
        burger.setAttribute('aria-expanded', String(isOpen));
        burger.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');

        if (!isOpen && mediaQuery.matches) {
            closeTopics(false);
        }
    };

    new MutationObserver(syncBurgerState).observe(head, {
        attributes: true,
        attributeFilter: ['class']
    });

    syncBurgerState();
    renderNavigation();

    if (logo && typeof imagesLoaded === 'function') {
        imagesLoaded(logo, scheduleRender);
    }

    window.addEventListener('load', scheduleRender, {once: true});
    window.addEventListener('resize', scheduleRender);
}